import { Component, Input, OnInit } from '@angular/core';

import { CourtEventNoteModel } from '@bayclubs/court-booking-employee-api';

@Component({
    selector: 'app-court-event-notes-info',
    templateUrl: './court-event-notes-info.component.html',
    styleUrls: ['./court-event-notes-info.component.scss'],
    standalone: false
})
export class CourtEventNotesInfoComponent implements OnInit {

    @Input() notes: CourtEventNoteModel[];

    constructor() { }

    ngOnInit(): void {
    }

}
